var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.checkIfPlanIsPremium
        ? _c("div", [
            _vm.currentSubscription
              ? _c("div", [
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-3xl text-center font-semibold minheight",
                    },
                    [_vm._v(_vm._s(_vm.price) + "/mo")]
                  ),
                  _vm.price === `$149`
                    ? _c(
                        "p",
                        {
                          staticClass: "text-sm text-center font-semibold mb-8",
                        },
                        [
                          _vm.price === `$149`
                            ? _c("span", [
                                _vm._v("+5 additional managers for $20/mo"),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-sm font-medium text-center leading-7 mb-4",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.managersCount) +
                          " Manager" +
                          _vm._s(_vm.manyManagers)
                      ),
                      _c("br"),
                      _vm._v("Unlimited Resources "),
                    ]
                  ),
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSFIVE" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSTEN" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSFIFTEEN" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSTWENTY" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSTWENTYFIVE" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSTHIRTY" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSTHIRTYFIVE" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSFORTY" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSFORTYFIVE" ||
                  _vm.currentSubscription.subscription_plan.inner_name ===
                    "PREMIUMPLUSFIFTY"
                    ? _c("div", [
                        _c("p", { staticClass: "text-sm text-center" }, [
                          _c("span", { staticClass: "font-semibold" }, [
                            _vm._v("NEW:"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.currentSubscription.subscription_plan
                                  .subscription_plan_access_permission
                                  .managers_count - 20
                              ) +
                              " Additional managers"
                          ),
                        ]),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-sm text-center font-semibold mb-8",
                          },
                          [
                            _vm._v(
                              " ($" +
                                _vm._s(
                                  Number(
                                    _vm.currentSubscription.subscription_plan
                                      .price
                                  ) /
                                    100 -
                                    149
                                ) +
                                ")"
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _c("div", [
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-3xl text-center font-semibold minheight",
                    },
                    [_vm._v(_vm._s(_vm.price) + "/mo")]
                  ),
                  _c(
                    "p",
                    { staticClass: "text-sm text-center font-semibold mb-8" },
                    [
                      _vm.price === `$149`
                        ? _c("span", [
                            _vm._v("+5 additional managers for $20/mo"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-sm font-medium text-center leading-7 mb-4",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.managersCount) +
                          " Manager" +
                          _vm._s(_vm.manyManagers)
                      ),
                      _c("br"),
                      _vm._v("Unlimited Resources "),
                    ]
                  ),
                ]),
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "text-3xl text-center font-semibold minheight" },
              [
                _vm._v(_vm._s(_vm.price) + "/mo "),
                _vm.price === `$149`
                  ? _c(
                      "p",
                      { staticClass: "text-sm text-center font-semibold mb-8" },
                      [
                        _vm.price === `$149`
                          ? _c("span", [
                              _vm._v("+5 additional managers for $20/mo"),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-sm font-medium text-center leading-7 mb-4" },
              [
                _vm._v(
                  _vm._s(_vm.managersCount) +
                    " Manager" +
                    _vm._s(_vm.manyManagers)
                ),
                _c("br"),
                _vm._v("Unlimited Resources "),
              ]
            ),
          ]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }